export const CircleCheck = ({ className = '' }: { className?: string }) => (
  <svg aria-hidden className={`text-primary ${className}`} fill="none" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15" cy="15" fill="currentColor" r="15" />
    <path
      d="M11.4448 19.2804 7.5562 15.4439C7.1229 15.0164 6.43406 15.0164 6.00076 15.4439C5.56746 15.8714 5.56746 16.551 6.00076 16.9785L10.656 21.5713C11.0893 21.9988 11.7892 21.9988 12.2225 21.5713L23.9995 9.9633C24.4328 9.53581 24.4328 8.85621 23.9995 8.42873C23.5662 8.00124 22.8773 8.00124 22.444 8.42873L11.4448 19.2804Z"
      fill="white"
    />
  </svg>
)
